import { createOMSClient } from './oms';
import { createAnalyticsClient } from './analytics';
export const createChordClient = config => {
  const oms = createOMSClient(config);
  const analytics = createAnalyticsClient(config);
  return {
    analytics,
    oms
  };
};